var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/calendar/calendar-grid-view.html';
var html = "<div class=week ng-repeat=\"week in $ctrl.details.weeks\"> <div class=dates ng-repeat=\"day in week\"> <div ng-class=\"{'day': true, 'dayDisabled': !day.isCurrentMonth, 'show-selected-date': day.isCurrentDate && day.isCurrentMonth}\" class=day>{{day.day}} </div> <div ng-if=day.details class=all_events> <ul class=evntDotA> <li uib-dropdown ng-repeat=\"detail in day.details\" ng-include=$ctrl.templateUrl> </li> </ul> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/calendar/calendar-grid-view.html
// module id = 905
// module chunks = 0